import { useDispatch, useSelector } from "react-redux";
import { fetchBooks } from "../../store/features/Book/actionCreator";
import { updateBook } from "../../store/features/Book/actionCreator";

export default function BookForm() {
  const dispatch = useDispatch();
  const updateBookData = useSelector((state) => state.book.updateBook);

  async function updateEditedBookData(bookData, form) {
    try {
      const response = await fetch(
        `http://localhost:9000/books/${updateBookData.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(bookData),
        }
      );

      if (response.status === 200) {
        dispatch(updateBook(null));
        dispatch(fetchBooks());
        form.reset();
      }
    } catch (error) {
      alert("Failed to update book data to server");
    }
  }

  async function addNewBook(bookData, form) {
    try {
      const response = await fetch("http://localhost:9000/books", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bookData),
      });

      if (response.status === 201) {
        dispatch(fetchBooks());
        form.reset();
      }
    } catch (error) {
      alert("Failed to post book data to server");
    }
  }

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const bookData = Object.fromEntries(formData);
    bookData.featured = bookData.featured === "on" ? true : false;

    if (updateBookData) {
      updateEditedBookData(bookData, form);
    } else {
      addNewBook(bookData, form);
    }
  };

  return (
    <div>
      <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
        <h4 className="mb-8 text-xl font-bold text-center">
          {updateBookData ? "Update book" : "Add New Book"}
        </h4>
        <form className="book-form" onSubmit={handleFormSubmit}>
          <div className="space-y-2">
            <label htmlFor="name">Book Name</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookname"
              name="name"
              defaultValue={updateBookData?.name}
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="category">Author</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookauthor"
              name="author"
              defaultValue={updateBookData?.author}
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="image">Image Url</label>
            <input
              required
              className="text-input"
              type="text"
              id="input-Bookthumbnail"
              name="thumbnail"
              defaultValue={updateBookData?.thumbnail}
            />
          </div>
          <div className="grid grid-cols-2 gap-8 pb-4">
            <div className="space-y-2">
              <label htmlFor="price">Price</label>
              <input
                required
                className="text-input"
                type="number"
                id="input-Bookprice"
                name="price"
                defaultValue={updateBookData?.price}
              />
            </div>
            <div className="space-y-2">
              <label htmlFor="quantity">Rating</label>
              <input
                required
                className="text-input"
                type="number"
                id="input-Bookrating"
                name="rating"
                min={1}
                max={5}
                defaultValue={updateBookData?.rating}
              />
            </div>
          </div>
          <div className="flex items-center">
            <input
              id="input-Bookfeatured"
              type="checkbox"
              name="featured"
              className="w-4 h-4"
              defaultChecked={updateBookData?.featured || false}
            />
            <label htmlFor="featured" className="ml-2 text-sm">
              {" "}
              This is a featured book{" "}
            </label>
          </div>
          <button type="submit" className="submit" id="submit">
            {updateBookData ? "Update Book" : "Add Book"}
          </button>
        </form>
      </div>
    </div>
  );
}
